<template>
  <div class="games-page">
    <div class="mobile-tab-selector" @click="showMobileMenu = !showMobileMenu">
      <span>{{ getMobileTabName }}</span>
      <i :class="['el-icon-arrow-down', {'el-icon-arrow-up': showMobileMenu}]"></i>
    </div>
    <div class="games-menu" :class="{'mobile-menu-active': showMobileMenu}">
      <div @click="selectTab('lucky-ball-5')" class="menu-item" :class="{ active: activeTab === 'lucky-ball-5' }">Lucky 5 Ball</div>
      <div @click="selectTab('how-to-play')" class="menu-item" :class="{ active: activeTab === 'how-to-play' }">How to play</div>
      <div @click="selectTab('ticket-prices')" class="menu-item" :class="{ active: activeTab === 'ticket-prices' }">Ticket prices</div>
      <div @click="selectTab('how-to-win')" class="menu-item" :class="{ active: activeTab === 'how-to-win' }">How to win</div>
    </div>
    <div class="games-content">
      <div v-if="activeTab === 'lucky-ball-5'">
        <div class="game-banner">
          <img :src="require('@/assets/images/ball5_new.png')" alt="Lucky 5 Ball">
        </div>

        <h1 class="page-title">Lucky 5 Ball</h1>
        
        <p class="game-description">
          Lucky 5 Ball is a fun game of chance with draws every 5 minutes! In every Lucky 5 Ball game 5 numbers are randomly generated from a possible 10 where the more numbers that you have selected are in order, the more you win.
        </p>

        <h2 class="section-title">Playing Lucky 5 Ball is easy</h2>
        
        <p class="game-description">
          Lucky 5 Ball is drawn every 5 minutes in every day, with 288 draws per day.
        </p>
        
        <p class="game-description">
          There are ten balls numbered 0 to 9 from which five winning numbers are randomly selected. You choose 1, 2, 3, or 5 numbers from 0 to 9 and match your numbers with the 5 balls.
        </p>
        
        <p class="game-description">
          There are two ways you can play Lucky 5 Ball:<br>
          - Marking a Lucky 5 Ball coupon with your favourite numbers; or<br>
          - Asking for a QuickPick and letting the terminal randomly generate the numbers for you.
        </p>

        <h2 class="section-title">Winning Lucky 5 Ball</h2>
        
        <p class="game-description">
          To win Division 1 in Lucky 5 Ball you must have the 5-digit Lucky 5 Ball numbers matching the exact sequence as the numbers drawn. You can also win a prize if your Lucky 5 Ball number matches the sequence of the numbers drawn. In all there are 5 prize divisions.
        </p>
      </div>

      <div v-else-if="activeTab === 'how-to-play'">
        <h1 class="page-title">How to Play Lucky 5 Ball</h1>
        
        <p class="game-description">
          Playing Lucky 5 Ball is easy! 5 balls are drawn at random from 10 balls numbered 0 to 9. You choose 5 numbers from 0 to 9 and the aim is to have the correct numbers in the order drawn. The more numbers in order, the more you win.
        </p>
        
        <p class="game-description">
          To win first division you need to match 5 numbers in a single game from the 5 balls from the draw.
        </p>

        <h2 class="section-title">Entry Types</h2>
        <h3 class="subsection-title">Mark a Lucky 5 Ball Coupon</h3>

        <p class="game-description">
          If you've got numbers that are really special to you they could mean more to you when you play Lucky 5 Ball. Just follow these simple steps:
        </p>

        <ol class="numbered-list">
          <li>Grab a Lucky 5 Ball Coupon at your local Lucky Lottery Outlet</li>
          <li>Mark 1 to 5 numbers in each game panel</li>
          <li>Play 1 - 18 game panels</li>
        </ol>

        <h2 class="section-title">Play with QuickPicks</h2>
        
        <p class="game-description">
          QuickPick Entries are perfect if you're in a rush or playing Lucky 5 Ball for the first time because your numbers are generated at random for you. QuickPick Entries are available in the following sizes.
        </p>

        <div class="quick-pick-table">
          <div class="table-row">
            <div class="table-cell">Maxi QuickPick</div>
            <div class="table-cell">50 games</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Jumbo QuickPick</div>
            <div class="table-cell">36 games</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Mega QuickPick</div>
            <div class="table-cell">25 games</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Super QuickPick</div>
            <div class="table-cell">18 games</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Regular QuickPick</div>
            <div class="table-cell">14 games</div>
          </div>
          <div class="table-row">
            <div class="table-cell">12 Game QuickPick</div>
            <div class="table-cell">12 games</div>
          </div>
          <div class="table-row">
            <div class="table-cell">6 Game QuickPick</div>
            <div class="table-cell">6 games</div>
          </div>
        </div>
      </div>

      <div v-else-if="activeTab === 'ticket-prices'">
        <h1 class="page-title">Ticket Prices</h1>
        
        <p class="game-description">
          The current Lucky 5 Ball prices are listed below.
        </p>

        <div class="price-table">
          <div class="table-header">
            <div class="header-cell">Entry Type</div>
            <div class="header-cell">Equiv. Standard Games</div>
            <div class="header-cell">Cost</div>
          </div>
          <div class="table-row">
            <div class="table-cell">6 Game QuickPick</div>
            <div class="table-cell">6</div>
            <div class="table-cell">$ 6.45</div>
          </div>
          <div class="table-row">
            <div class="table-cell">12 Game QuickPick</div>
            <div class="table-cell">12</div>
            <div class="table-cell">$ 12.90</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Regular QuickPick</div>
            <div class="table-cell">14</div>
            <div class="table-cell">$ 15.05</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Super QuickPick</div>
            <div class="table-cell">18</div>
            <div class="table-cell">$ 19.35</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Mega QuickPick</div>
            <div class="table-cell">25</div>
            <div class="table-cell">$ 26.90</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Jumbo QuickPick</div>
            <div class="table-cell">36</div>
            <div class="table-cell">$ 38.70</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Maxi QuickPick</div>
            <div class="table-cell">50</div>
            <div class="table-cell">$ 53.80</div>
          </div>
        </div>

        <div class="price-table">
          <div class="table-header">
            <div class="header-cell">Entry Type</div>
            <div class="header-cell">Equiv. Standard Games</div>
            <div class="header-cell">Cost</div>
          </div>
          <div class="table-row">
            <div class="table-cell">1 Game</div>
            <div class="table-cell">1</div>
            <div class="table-cell">$ 1.10</div>
          </div>
          <div class="table-row">
            <div class="table-cell">2 Game</div>
            <div class="table-cell">2</div>
            <div class="table-cell">$ 2.15</div>
          </div>
          <div class="table-row">
            <div class="table-cell">3 Game</div>
            <div class="table-cell">3</div>
            <div class="table-cell">$ 3.25</div>
          </div>
          <div class="table-row">
            <div class="table-cell">4 Game</div>
            <div class="table-cell">4</div>
            <div class="table-cell">$ 4.30</div>
          </div>
          <div class="table-row">
            <div class="table-cell">5 Game</div>
            <div class="table-cell">5</div>
            <div class="table-cell">$ 5.40</div>
          </div>
        </div>
      </div>

      <div v-else-if="activeTab === 'how-to-win'">
        <h1 class="page-title">How to Win Lucky 5 Ball</h1>
        
        <p class="game-description">
          To win a prize in Lucky 5 Ball, you need to match at least 1 winning number on your Lucky 5 Ball entry. Prizes are paid for the following winning number combinations:
        </p>

        <div class="prize-table">
          <div class="table-header">
            <div class="header-cell">Division</div>
            <div class="header-cell">Matching Numbers</div>
            <div class="header-cell">Prize</div>
          </div>
          <div class="table-row">
            <div class="table-cell">One</div>
            <div class="table-cell">5</div>
            <div class="table-cell">$ 100,000</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Two</div>
            <div class="table-cell">4</div>
            <div class="table-cell">$ 10,000</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Three</div>
            <div class="table-cell">3</div>
            <div class="table-cell">$ 1,000</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Four</div>
            <div class="table-cell">2</div>
            <div class="table-cell">$ 100</div>
          </div>
          <div class="table-row">
            <div class="table-cell">Five</div>
            <div class="table-cell">1</div>
            <div class="table-cell">$ 10</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Games',
  data() {
    return {
      activeTab: 'lucky-ball-5',
      showMobileMenu: false
    }
  },
  computed: {
    getMobileTabName() {
      switch(this.activeTab) {
        case 'lucky-ball-5': return 'Lucky 5 Ball';
        case 'how-to-play': return 'How to play';
        case 'ticket-prices': return 'Ticket prices';
        case 'how-to-win': return 'How to win';
        default: return 'Lucky 5 Ball';
      }
    }
  },
  methods: {
    selectTab(tab) {
      this.activeTab = tab;
      this.showMobileMenu = false;
    }
  },
  created() {
    // Initialize tab based on route if present
    if (this.$route.params.game) {
      this.activeTab = this.$route.params.game;
    }
  }
}
</script>

<style scoped>
.games-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 30px;
  box-sizing: border-box;
}

.games-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-item {
  padding: 12px 15px;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  border-radius: 4px;
  transition: all 0.3s;
  cursor: pointer;
}

.menu-item:hover,
.menu-item.active {
  background-color: #4caf50;
  color: white;
  box-shadow: 0 2px 5px rgba(76, 175, 80, 0.3);
}

.games-content {
  background: white;
  border-radius: 4px;
  padding: 25px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.game-banner {
  margin-bottom: 25px;
  overflow: hidden;
  border-radius: 4px;
  background-color: #fcf5f2;
  text-align: center;
  padding: 20px;
}

.game-banner img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.page-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
  border-bottom: 2px solid #4caf50;
  padding-bottom: 10px;
}

.section-title {
  font-size: 22px;
  color: #333;
  margin: 30px 0 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.subsection-title {
  font-size: 18px;
  color: #333;
  margin: 20px 0 10px;
}

.game-description {
  color: #555;
  line-height: 1.6;
  margin-bottom: 15px;
  font-size: 16px;
}

.numbered-list {
  padding-left: 20px;
  margin-bottom: 20px;
}

.numbered-list li {
  margin-bottom: 10px;
  color: #555;
  line-height: 1.6;
}

.quick-pick-table,
.price-table,
.prize-table {
  width: 100%;
  margin: 20px 0 30px;
  border-collapse: collapse;
}

.table-header,
.table-row {
  display: flex;
  border-bottom: 1px solid #eee;
}

.table-header {
  background-color: #ffecec;
  border-top: 1px solid #eee;
}

.header-cell,
.table-cell {
  padding: 12px 15px;
  text-align: left;
  flex: 1;
}

.header-cell {
  font-weight: bold;
  color: #333;
}

.table-cell {
  color: #555;
}

.table-row:nth-child(odd) {
  background-color: #ffecec;
}

.mobile-tab-selector {
  display: none;
  padding: 15px;
  background-color: #4caf50;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 5px rgba(76, 175, 80, 0.3);
}

@media (max-width: 768px) {
  .games-page {
    grid-template-columns: 1fr;
    padding: 15px;
    gap: 15px;
  }
  
  .mobile-tab-selector {
    display: flex;
  }
  
  .games-menu {
    display: none;
    position: absolute;
    z-index: 10;
    background: white;
    width: calc(100% - 30px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    border-radius: 4px;
    margin-top: -10px;
  }
  
  .games-menu.mobile-menu-active {
    display: flex;
  }
  
  .games-content {
    padding: 20px 15px;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 24px;
  }
  
  .section-title {
    font-size: 20px;
  }
  
  .subsection-title {
    font-size: 16px;
  }
  
  .game-description, .numbered-list li {
    font-size: 14px;
  }
  
  .table-header, .table-row {
    flex-direction: column;
  }
  
  .header-cell, .table-cell {
    text-align: center;
    padding: 8px;
  }
  
  .header-cell {
    background-color: #ffecec;
  }
  
  .table-row {
    margin-bottom: 15px;
    border: 1px solid #eee;
  }
  
  .games-content {
    padding: 15px 10px;
  }
  
  .games-page {
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Games.vue